<template>
  <qtm-autocomplete v-bind="$attrs" :item-title="itemTitle" :items="equipment" placeholder="Select Equipment" />
</template>

<script setup lang="ts">
import type { Equipment } from '@quotetome/materials-api'

export interface Props {
  equipment: Equipment[]
}

defineProps<Props>()

const itemTitle = (e: Equipment) => `${e.equipment_number} - ${e.description}`
</script>
